import type { SelectItem } from '@mantine/core';
export type Vocal = 'none' | 'voc' | 'dh';
export type Phonogram = 'ОРГИНАЛ' | 'ХИЙСЭН';
export type License = 'NEXT GALAXY' | 'MOSCAP' | 'MCPP' | 'НДХ' | 'NEXT';
export type Contract = 'ХЭЛЦЭЛ' | 'УРАМШУУЛАЛ' | 'ХЭЛЦЭЛ / УРАМШУУЛАЛ';

export const CLIENT_ROUTE = '/song';
export const API_ROUTE = '/api/song'
export const CLIENT_TITLE = 'Дуу';

export interface IVocalItem {
    value: Vocal;
    label: string;
}

export interface ILicenseItem {
    value: License;
    label: string;
}

export const vocalItems: IVocalItem[] = [
    { value: "none", label: 'Байхгүй' },
    { value: "voc", label: 'Вокалтай' },
    { value: "dh", label: 'Дахилт вокалтай' },
];

export const phonograms: Phonogram[] = [
    'ОРГИНАЛ',
    'ХИЙСЭН'
]

export const licenseItems: ILicenseItem[] = [
    { value: "NEXT", label: 'NEXT GALAXY' },
    { value: "NEXT GALAXY", label: 'NEXT GALAXY' },
    { value: "MOSCAP", label: 'MOSCAP' },
    { value: "MCPP", label: 'MCPP' },
    { value: "НДХ", label: 'НДХ' },
]

export const contractItems: Contract[] = [
    'ХЭЛЦЭЛ',
    'УРАМШУУЛАЛ',
    'ХЭЛЦЭЛ / УРАМШУУЛАЛ',
]